import React from "react";
import AddonSection from "../../component/addons/AddonSection";

function Addons() {
  return (
    <div className="page-body">
      <AddonSection />
    </div>
  );
}

export default Addons;
